<template>
  <!-- Formulario de adicion de nodos -->
  <div id="formulario-grupos" style="width: 100%">
    <circle-loader ref="circleLoader" />

    <div v-if="!submitted">
      <!-- INIT FORMULARIO DE ADICION -->
      <b-row>
        <b-col>
          <b-form @submit="saveGroup">
            <p>Datos de la agrupación</p>
            <div class="groupBox" style="min-width: 400px; min-height: 340px">
              <!-- Fila 1 -->
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Alias de la agrupacion*"
                    label-for="alias"
                  >
                    <b-form-input
                      id="alias"
                      name="alias"
                      size="sm"
                      placeholder="..."
                      v-model="currentGroup.alias"
                      :value="currentGroup.alias"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <!-- Fila 5 -->
                  <b-row>
                    <b-col>
                      <small>* El campo debe ser rellenado</small><br />
                    </b-col>
                  </b-row>

                  <!-- Fila 6 -->
                  <b-row style="margin-top: 60px">
                    <b-col>
                      <form-button
                        style="width: 200px"
                        label="Guardar agrupación"
                        size="sm"
                        customType="submit"
                        v-bind:block="true"
                        v-if="isUserAdmin()"
                      />
                    </b-col>
                    <b-col>
                      <form-button
                        style="width: 120px"
                        label="Salir"
                        size="sm"
                        customType="exit"
                        v-bind:block="true"
                        @click="exitForm"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </b-col>
        <!-- INIT ADD sensors -->
        <b-col>
          <p>Sensores disponibles</p>
          <div class="groupBox" style="min-width: 300px; min-height: 340px">
            <!-- Fila 3 -->
            <b-row>
              <b-col>
                <b-form-group
                  label-size="sm"
                  label="Seleccione una ubicación"
                  label-for="location"
                >
                  <b-form-select
                    size="sm"
                    id="location"
                    name="location"
                    v-model="selectedLocation"
                    style="cursor: pointer"
                    @change="retrieveNodes"
                  >
                    <b-form-select-option value="null" selected
                      >Ninguna ubicación</b-form-select-option
                    >
                    <b-form-select-option
                      v-for="location in locationList"
                      v-bind:key="location.alias"
                      v-bind:value="location"
                    >
                      {{ location.alias }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Fila 4 -->
            <b-row>
              <b-col>
                <b-form-group
                  label-size="sm"
                  label="Seleccione un nodo"
                  label-for="node"
                >
                  <b-form-select
                    size="sm"
                    id="node"
                    name="node"
                    v-model="selectedNode"
                    style="cursor: pointer"
                    @change="retrieveSensors"
                  >
                    <b-form-select-option value="null" selected
                      >Ningun nodo</b-form-select-option
                    >
                    <b-form-select-option
                      v-for="node in nodeList"
                      v-bind:key="node.alias"
                      v-bind:value="node"
                    >
                      {{ node.alias }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Fila 5 -->
            <b-row>
              <b-col>
                <b-form-group
                  label-size="sm"
                  label="Seleccione un sensor"
                  label-for="sensor"
                >
                  <b-form-select
                    size="sm"
                    id="sensor"
                    name="sensor"
                    v-model="selectedSensor"
                    style="cursor: pointer"
                  >
                    <b-form-select-option value="null"
                      >Ningun sensor</b-form-select-option
                    >
                    <b-form-select-option
                      v-for="sensor in sensorList"
                      v-bind:key="sensor.alias"
                      v-bind:value="sensor"
                    >
                      {{ sensor.description }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Fila 6 -->
            <b-row style="margin-top: 20px">
              <b-col class="text-center">
                <b-button
                  style="width: 200px"
                  type="button"
                  variant="secondary"
                  class="btn btn-sm"
                  @click="addToGroupList"
                  v-if="isUserAdmin()"
                  >Agregar a la lista
                  <i
                    class="fas fa-chevron-circle-right"
                    style="margin-left: 10px"
                  ></i
                ></b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <!-- END ADD sensors -->
        <!-- INIT ADD sensors -->
        <b-col>
          <p>Lista de sensores seleccionados</p>
          <div class="groupBox" style="min-height: 340px">
            <b-list-group>
              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
                style="padding: 5px 15px 5px 15px !important;"
                v-for="(sensor, index) in sensorGroupList"
                :key="index"
                :value="sensor"
              >
                {{ sensor.description }}
                <b-badge
                  title="Quitar sensor de la lista"
                  variant="danger"
                  style="cursor: pointer"
                  pill
                  @click="delToGroupList(index)"
                  >X</b-badge
                >
              </b-list-group-item>
            </b-list-group>
            <div v-if="sensorGroupList == 0">
              <p  style="font-size:0.8rem;">Seleccione los sensores que desee incluir en el listado que conformaran la nueva agrupación de sensores</p>
            </div>
          </div>
        </b-col>
        <!-- END ADD sensors -->
      </b-row>
      <!-- END FORMULARIO DE ADICION -->
    </div>
    <!-- END V if submitted-->
  </div>
</template>


<script>
import SensorService from "@/services/SensorService";
import GroupService from "@/services/GroupService";
import LocationService from "@/services/LocationService";
import DeviceService from "@/services/DeviceService";
import UserService from "@/services/UserService";

import CircleLoader from "@/components/common/CircleLoader";
import Button from "@/components/common/form/Button";

export default {
  name: "group-edit-form",
  components: {
    "circle-loader": CircleLoader,
    "form-button": Button,
  },
  data() {
    return {
      currentGroup: {},
      locationList: [],
      nodeList: [],
      sensorList: [],
      sensorGroupList: [],
      selectedLocation: null,
      selectedNode: null,
      selectedSensor: null,
      submitted: false,
      disabledInput: false,
      parentLocation: null
    };
  },
  mounted() {
    //Cargamos las ubicaciones
    this.retrieveLocations();
  },

  methods: {

    retrieveGroupDetails(idgroup, location) {
      //Delay de carga
      this.loadDelay()
      this.retrieveLocations(location)
      this.parentLocation = location
      
      //Get device data
      GroupService.get(idgroup)
        .then(response => {
          this.currentGroup = response.data
          this.sensorGroupList = response.data.sensor
        })
        .catch(e => {
          console.log(e);
        });    
    },
    

    retrieveLocations(parentLocation) {
      //Store current selected tab location
      this.parentLocation = parentLocation
      //Populate location list
      LocationService.getAll()
        .then((response) => {
          this.locationList = response.data;
        })
        .catch((e) => {
          console.log("Error retrieving location list");
          console.log(e);
        });
    },

    retrieveNodes() {
      DeviceService.getDevicesFromLocation(this.selectedLocation._id)
        .then((response) => {
          this.nodeList = response.data;
        })
        .catch((e) => {
          console.log("Error retrieving node list");
          console.log(e);
        });
    },

    retrieveSensors() {
      SensorService.getSensorsFromDevice(this.selectedNode._id)
        .then((response) => {
          this.sensorList = response.data;
        })
        .catch((e) => {
          console.log("Error retrieving sensor list");
          console.log(e);
        });
    },

    addToGroupList() {
      if(this.sensorGroupList.includes(this.selectedSensor)){
        //El elemento ya existe
      }else{
        // Lo metemos en el array
        this.sensorGroupList.push(this.selectedSensor);
      }
    },

    delToGroupList(index) {
      if (index >= 0) {
        this.sensorGroupList.splice(index, 1);
      }
    },


    loadDelay(){
      //Cargamos el div oculto
      this.submitted = true;
      this.$refs.circleLoader.showLoading('Cargando datos del grupo...');

      //Timeout para cambiar de pagina
      setTimeout(()=>{
        //Cambiamos de div
        this.submitted = false
        this.$refs.circleLoader.reset();
      },500);
    },

    exitForm() {
      this.$emit("onClickExit");
    },

    saveGroup(e) {
      //Prevent submit
      e.preventDefault();

      if (this.currentGroup._id) {
        this.updateGroup();
      } else {
        this.createGroup();
      }
    },

    async createGroup() {
      try {
        let data;
        let sensorIdList = [];

        this.$refs.circleLoader.reset();
        this.$refs.circleLoader.showLoading("Registrando grupo ...");

        for await (let sensor of this.sensorGroupList) {
          if (sensor._id) {
            sensorIdList.push(sensor._id);
          }
        }

        data = {
          alias: this.currentGroup.alias,
          maxFreq: this.currentGroup.maxFreq,
          sensor: sensorIdList,
          location_ref: this.parentLocation
        };
        let response = await GroupService.create(data);


        this.submitted = true;
        //Mostramos durante 2 segundos que se está gaurdando
        setTimeout(() => {
          //Checkar cabeceras e vuelta para cargar la X o el tick
          if (!response.data.message) {
            this.$refs.circleLoader.showEndError(
              "No se ha podido registrar el nodo"
            );
          } else {
            this.$refs.circleLoader.showEndSuccess(
              "Nodo almacenado correctamente"
            );
          }
          //Temporizador antes de mostrar de nuevo el formulario
          setTimeout(() => {
            this.submitted = false;
            //Emit event to notify parent to notify the other component
            this.$emit("onClickSave");
          }, 1500);
        }, 2500);
      } catch (error) {
        let errorMessage = error;

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }

        this.$notify({
          group: "notificateDiv",
          type: "error",
          title: "Error al guardar el grupo",
          text: errorMessage,
          duration: 3000,
          speed: 1000,
        });

        throw new Error("Error - GroupsEditForm.vue - createGroup");
      }
    },



    async updateGroup() {
      try{
        let data;
        let sensorIdList = [];

        for await (let sensor of this.sensorGroupList) {
          if (sensor._id) {
            sensorIdList.push(sensor._id);
          }
        }

        data = {
          _id: this.currentGroup._id,
          alias: this.currentGroup.alias,
          maxFreq: this.currentGroup.maxFreq,
          sensor: sensorIdList,
          location_ref: this.parentLocation
        };

        //Disable buttons before re-enabled
        this.disabledInput = true; 

        // Actual update
        let responseGroup = await GroupService.update(data)
        
        this.$notify({
            group: 'notificateDiv',
            type: 'success',
            title: responseGroup.data.message ? responseGroup.data.message : 'Grupo modificado correctamente',
            text: responseGroup.data.message ? "" : 'Se ha modificado el grupo seleccionado',
            duration: 3000,
            speed: 1000
        });

        //delay antes de rehabilitarlos
        setTimeout(()=>{
          //Avisamos al parent de que cambie componente
          this.disabledInput = false;
        },500);
        
        //Rehabilitiamso lso botones de nuevo
        this.disabledInput = false;

        //Refresh table list (parent signal)
        this.$emit('onClickSave')
      }
      catch (error) {
        let errorMessage = error;

        if(error && error.response && error.response.data && error.response.data.message){
          errorMessage = error.response.data.message
        }

        this.$notify({
             group: 'notificateDiv',
             type: 'error',
             title: 'Error al guardar los cambios',
             text: errorMessage,
             duration: 3000,
             speed: 1000
          });
        console.log(error)
        throw new Error('Error - GroupsEditForm.vue - updateGroup')
      }
    },



    isUserAdmin() {
      return UserService.isUserAdmin();
    },
  },
};
</script>

<style lang="scss" scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 15px;
}
</style>